<template>
    <div id="role">
        <div class="search-box">
            <p>角色编码：</p>
            <a-input allow-clear v-model="roleCode"/>
            <p>角色名称：</p>
            <a-input allow-clear v-model="roleName"/>
            <a-button type="primary" icon="search" class="search-btn" @click="searchTable">搜索</a-button>
            <a-button type="primary" icon="plus" class="add-btn" @click="okText='新增';showAdd=true" v-if="permissions.includes('back:role:add')">新增</a-button>
        </div>
        <a-table
            rowKey="id"
            :columns="columns"
            :data-source="data"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
            bordered
        >
            <span slot="idNum">{{pagination.pageSize}}</span>
            <span slot="id" slot-scope="text, record">
                <a @click="editPower(record)" v-if="permissions.includes('back:role:update')">编辑</a>
                <a-divider type="vertical"/>
                <a @click="viewUsers(record.id)">查看用户</a>
                <a-divider type="vertical"/>
                <a @click="addUsers(record.id)" v-if="permissions.includes('back:role:user:set')">添加用户</a>
                <a-divider type="vertical"/>
            <a-dropdown>
                <a class="ant-dropdown-link">
                更多 <a-icon type="down"/>
                </a>
                <a-menu slot="overlay">
                <a-menu-item v-if="permissions.includes('back:role:delete')">
                    <a @click="delPower(record)">删除</a>
                </a-menu-item>
                <a-menu-item v-if="permissions.includes('back:role:permission:set')">
                    <a @click="addPermission(record.id)">授权</a>
                </a-menu-item>
                <a-menu-item v-if="permissions.includes('back:role:menu:set')">
                    <a @click="handlePermission(record.id)">菜单</a>
                </a-menu-item>
                </a-menu>
            </a-dropdown>
            </span>
            <template slot="name" slot-scope="name"> {{ name.first }} {{ name.last }} </template>
        </a-table>
        <a-modal v-model="showAdd" :title="okText+'角色'" @ok="addPower" @cancel='cancelAdd' cancelText="取消" :okText='okText'>
            <div class="input-box">
                <p>角色编码：</p>
                <a-input allow-clear v-model="addCode" maxLength='50' :disabled="okText!='新增'?true:false"/>
            </div>
            <div class="input-box">
                <p>角色名称：</p>
                <a-input allow-clear v-model="addName" maxLength='50'/>
            </div>
            <div class="input-box">
                <p style="vertical-align: top;">备注：</p>
                <a-textarea
                    v-model="addRemark"
                    :auto-size="{ minRows: 3,maxRows: 3}"
                    maxLength='200'
                />
            </div>
        </a-modal>
        <!-- <a-modal v-model="showConfig" title="配置权限" @ok="configOk" @cancel='cancelConfig' cancelText="取消" okText='配置'>
            <div class="input-box">
                <p>权限：</p>
                <a-select
                    mode="multiple"
                    :default-value="selectPower"
                    @change="handleChange"
                >
                    <a-select-option v-for="item in powerList" :key="item.id">{{ item.name }}</a-select-option>
                </a-select>
            </div>
        </a-modal> -->
        <role-permission-modal ref="rolePermissionModal"></role-permission-modal>
        <view-user-list-modal ref="viewuserlistModal"></view-user-list-modal>
        <add-users-modal ref="addusersModal" @ok="searchTable"></add-users-modal>
        <add-permission-modal ref="addpermissionModal" @ok="searchTable"></add-permission-modal>
    </div>
</template>

<script>
import { TreeSelect } from 'ant-design-vue';
import RolePermissionModal from './modules/RolePermissionModal'
import ViewUserListModal from './modules/ViewUserListModal'
import AddUsersModal from './modules/AddUsersModal'
import AddPermissionModal from './modules/AddPermissionModal'
import { mapState } from 'vuex'
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const columns = [
  {
    title: '序号',
    dataIndex: 'idNum',
  },
  {
    title: '角色编码',
    dataIndex: 'code',
  },
  {
    title: '角色名称',
    dataIndex: 'name',
  },
  {
    title: '用户数量',
    dataIndex: 'count',
  },
  {
    title: '备注',
    dataIndex: 'remark',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
  },
  {
    title: '操作',
    dataIndex: 'id',
    width: 320,
    scopedSlots: { customRender: 'id' },
  },
];
export default {
  name: 'Role',
  components: {
      RolePermissionModal,
      ViewUserListModal,
      AddUsersModal,
      AddPermissionModal
  },
  computed: {
    ...mapState({
      permissions: state => state.user.permissions
    })
  },
  data() {
    return {
        data: [],
        pagination: {},
        loading: false,
        columns,
        roleCode:'',
        roleName:'',
        tableSize:'10',
        showAdd: false,
        addCode:'',
        addName:'',
        addRemark:'',
        okText:'',
        putId:'',
        // showConfig:false,
        // powerList:[],
        // selectPower:[],
        // menuList:[],
        // selectMenu:[],
        // configId:'',
        SHOW_PARENT,
        // menuData:[],
    }
  },
  mounted () {
    this.fetch({
        size: this.tableSize,
        current: 1,
        code:this.roleCode,
        name:this.roleName,
    });
    // this.baseAPI.axiosData('/api-u/permissions?size=9999&current=1','get',{}).then(res => {
    //     this.powerList=res.data.records
    // })
    // this.baseAPI.axiosData('/api-u/menus/tree','get',{}).then(res => {
    //     this.menuList=res.data
    // })
  },
  methods:{
    handlePermission (roleId) {
      this.$refs.rolePermissionModal.show(roleId)
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.fetch({
        size: pagination.pageSize,
        current: pagination.current,
        code:this.roleCode,
        name:this.roleName,
      });
    },
    fetch(params = {}) {
        this.pagination = params;
        this.loading = true;
        this.baseAPI.axiosData('/api-u/roles?size='+params.size+'&current='+params.current+'&name='+params.name+'&code='+params.code,'get',{}).then(res => {
            const pagination = { ...this.pagination };
            params.size+=''
            pagination.pageSize = params.size-0;
            pagination.total = res.data.total;
            for(let i=0;i<res.data.records.length;i++)
            {
                res.data.records[i].idNum=(params.size*(params.current-1))+i+1;
            }
            this.loading = false;
            this.data = res.data.records;
            this.pagination = pagination;
        })
    },
    searchTable()
    {
        this.fetch({ 
            size: this.tableSize,
            current: 1,
            code:this.roleCode,
            name:this.roleName,
        });
    },
    addPower()
    {
        if(this.okText=='新增')
        {
            let dataObj={
                code:this.addCode,
                name:this.addName,
                remark:this.addRemark,
            }
            this.baseAPI.axiosData('/api-u/roles','post',dataObj).then(res => {
                this.refreshTable(res,"添加");
            })
        }
        else if(this.okText=='修改')
        {
            let dataObj={
                code:this.addCode,
                name:this.addName,
                remark:this.addRemark,
                id:this.putId,
            };
            this.baseAPI.axiosData('/api-u/roles','PUT',dataObj).then(res => {
                this.refreshTable(res,"修改成功");
            })
        }
    },
    refreshTable(res,text){
        if(res.data.success)
        {
            this.$notification['success']({
                message: text,
            });
        }
        else
        {
            this.$notification['error']({
                message: res.data.errorMessage,
            });
        }
        this.addCode='';
        this.addName='';
        this.addRemark='';
        this.showAdd = false;
        this.fetch({ 
            size: this.tableSize,
            current: 1,
            code:this.roleCode,
            name:this.roleName,
        });
    },
    cancelAdd(){
        this.addCode='';
        this.addName='';
        this.addRemark='';
    },
    editPower(obj){
        this.putId=obj.id;
        this.addCode=obj.code;
        this.addName=obj.name;
        this.addRemark=obj.remark;
        this.okText='修改';
        this.showAdd=true;
    },
    delPower(obj){
        var that=this;
        this.$confirm({
            title: '警告',
            content: '确定删除该角色吗？',
            okText: '确认',
            cancelText: '取消',
            onOk() {
                that.baseAPI.axiosData('/api-u/roles/'+obj.id,'DELETE',{}).then(res => {
                    if(res.data.success)
                    {
                        that.$notification['success']({
                            message: '删除成功',
                        });
                    }
                    else
                    {
                        that.$notification['error']({
                            message: res.data.errorMessage,
                        });
                    }
                    that.fetch({ 
                        size: that.tableSize,
                        current: 1,
                        code:that.roleCode,
                        name:that.roleName,
                    });
                })
                // return new Promise((resolve, reject) => {
                //     setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                // }).catch(() => console.log('Oops errors!'));
            },
            onCancel() {},
        });
    },
    addPermission(id){
        this.$refs.addpermissionModal.show(id)
    },
    // qxConfig(id){
        // this.configId=obj.id;
        // this.baseAPI.axiosData('/api-u/roles/'+obj.id+'/permissions','get',{}).then(res=>{
        //     console.log(res);
        //     this.selectPower=[];
        //     for(let i=0;i<res.data.length;i++)
        //     {
        //         this.selectPower.push(res.data[i].id);
        //     }
        //     this.showConfig=true;
        // })
    // },
    // handleChange(value) {
    //     this.selectPower=value
    // },
    // configOk(){
    //     this.baseAPI.axiosData('/api-u/roles/'+this.configId+'/permissions','post',this.selectPower).then(res=>{
    //         console.log(res);
    //         this.$notification['success']({
    //             message: '配置权限成功',
    //         });
    //         this.showConfig=false;
    //     })
    // },
    // cancelConfig(){
    //     this.menuData=[];
    //     this.showConfig=false;
    //     this.configText='';
    // },
    viewUsers (id) {
      this.$refs.viewuserlistModal.show(id)
    },
    addUsers (id) {
      this.$refs.addusersModal.show(id)
    },
}
}
</script>

<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
        margin-left: 2rem;
    }
    .search-box p:nth-child(1)
    {
        margin-left: 0;
    }
    .search-box .ant-input-affix-wrapper
    {
        width: 14rem;
    }
    .search-box .search-btn
    {
        margin-left: 2rem;
    }
    .search-box .add-btn
    {
        float: right;
    }
    .input-box
    {
        margin-bottom: 1rem;
    }
    .input-box p
    {
        display: inline-block;
        width: 20%;
        text-align: right;
    }
    .input-box .ant-input-affix-wrapper,textarea.ant-input,.ant-select
    {
        width: 80%;
    }
    .anticon,.iconfont
    {
        font-size: 20px;
        margin-right: 1rem;
        cursor: pointer;
    }
    .anticon:hover
    {
        color: #1890ff;
    }
    a{
      display: inline-block;
      text-decoration: none;
      color: #1F5EFF;
    }
</style>
